import { render, staticRenderFns } from "./DocumentHeaderInfo.vue?vue&type=template&id=f7bf30a8&scoped=true&lang=pug&"
import script from "./DocumentHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./DocumentHeaderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bf30a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
